/** @jsx jsx */
import { jsx, Flex, Styled } from "theme-ui"
import PropTypes from "prop-types"
import BackgroundImage from "gatsby-background-image"

const Card = ({ children, fluid, imgHeight }) => (
  <Flex
    sx={{
      bg: "dark",
      color: "background",
      flexDirection: "column",
      height: "100%",
    }}
  >
    <BackgroundImage
      sx={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: imgHeight,
        width: "100%",
        verticalAlign: "top",
      }}
      fluid={fluid}
      alt=""
    />
    <Styled.p
      sx={{ display: "block", my: 0, py: 3, px: 4, textAlign: "center" }}
    >
      {children}
    </Styled.p>
  </Flex>
)

Card.defaultProps = {
  imgHeight: "350px",
}

Card.propTypes = {
  children: PropTypes.any,
  fluid: PropTypes.any,
  imgHeight: PropTypes.oneOf([
    PropTypes.number,
    PropTypes.array,
    PropTypes.string,
  ]),
}

export default Card
